import axios, { AxiosError } from 'axios';

let isLogoutInProgress = false;

/**
 * Setup axios interceptor to handle 401 errors globally
 * When a 401 error occurs, we force logout to clear invalid session
 */
export const setupAxiosInterceptor = (logout: () => void) => {
  // Response interceptor
  axios.interceptors.response.use(
    (response) => {
      // Return successful responses as-is
      return response;
    },
    (error: AxiosError) => {
      // Check if this is a 401 Unauthorized error
      if (error.response?.status === 401 && !isLogoutInProgress) {
        console.error('❌ [Auth] Received 401 Unauthorized - session expired or invalid');
        console.error('🔐 [Auth] Forcing logout to clear invalid session');

        // Prevent multiple simultaneous logout calls
        isLogoutInProgress = true;

        // Clear any stored tokens/data
        localStorage.removeItem('selectedProjectId');
        localStorage.removeItem('auth_redirect_url');

        // Force logout
        logout();

        // Reset flag after a delay
        setTimeout(() => {
          isLogoutInProgress = false;
        }, 1000);
      }

      // Reject with the original error
      return Promise.reject(error);
    }
  );

  console.log('✅ [Auth] Axios interceptor configured for automatic 401 handling');
};
